import { apiCall } from './generated/gqlClient';

const getCurrentReservationsApiRequest = async () => {
  const query = `
    query getCurrentReservations {
      getCurrentReservations {
        id
        userId
        providerId
        serviceId
        startTime
        endTime
        userEmail
        fullname
        phone
        serviceName
        serviceDuration
        serviceCapacity
      }
    }
  `;

  return apiCall({ query });
};

const cancelReservationApiRequest = async reservationId => {
  const mutation = `
    mutation cancelReservation($reservationId: Int!) {
      cancelReservation(reservationId: $reservationId) {
        id
        message
        success
      }
    }
  `;
  return apiCall({ query: mutation, variables: { reservationId } });
};

const getReservationPriceApiRequest = async reservationId => {
  const query = `
    query getReservationPrice($reservationId: Int!) {
      getReservationPrice(reservationId: $reservationId) {
        price
      }
    }
  `;
  return apiCall({ query, variables: { reservationId } });
};
const getCustomersSubserviceReservationsApiRequest = async (subserviceId, userId, customerId) => {
  const query = `
    query getCustomersSubserviceReservations($subserviceId: Int!, $userId: Int, $customerId: Int) {
      getCustomersSubserviceReservations(subserviceId: $subserviceId, userId: $userId, customerId: $customerId) {
        future {
          id
          startTime
          endTime
          presence
          subService {
            name
          }
        }
        past {
          id
          startTime
          endTime
          presence
          subService {
            name
          }
        }
      }
    }
  `;
  return apiCall({ query, variables: { subserviceId, userId, customerId } });
};

export { cancelReservationApiRequest, getCurrentReservationsApiRequest, getCustomersSubserviceReservationsApiRequest, getReservationPriceApiRequest };
